import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ILookupValue } from '../models/lookupvalues';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  getTitelPrefix(): Map<number, string> {
    return new Map([
      [1, 'Dipl.-Ing.'],
      [2, 'Dr.'],
      [3, 'Mag.'],
      [4, 'Ing.']
    ]);
  }
  getTitelSuffix(): Map<number, string> {
    return new Map([
      [1, 'B.A.'],
      [2, 'B.Ed.'],
      [3, 'B.Eng.'],
      [4, 'B.Sc.'],
      [5, 'Bakk.'],
      [6, 'LL.B.'],
      [7, 'LL.M.'],
      [8, 'M.A.'],
      [9, 'M.A.I.S.'],
      [10, 'M.B.A.'],
      [11, 'M.Ed.'],
      [12, 'M.Eng.'],
      [13, 'M.Sc.'],
      [14, 'Ph.D.']
    ]);
  }

  antragsarten: Map<number, string> =
    new Map([
      [1, 'Neuantrag'],
      [2, 'Fahrzeugwechsel'],
      [3, 'Versicherungswechsel'],
      [4, 'Wechselkennzeicheneinschluss'],
      [5, 'Änderung HDI Versicherung']
    ]);

  hvPaketTeaserTexte: Map<number, string> =
    new Map([
      [1, 'Schützen Sie sich vor teuren Schäden durch Hochwasser, Überschwemmung und andere Naturkatastrophen.'],
      [2, 'Schutzpaket für Ihre Geräte, zum Beispiel Fernseher, Computer, Wasch- und Geschirrspülmaschinen.'],
      [3, 'Absicherung für Ihren Garten mit Ausstattung - von Pflanzen über Griller und Rasenmäher bis zur Gartenhütte.'],
      [4, 'Sichern Sie Ihre Fahrräder zusätzlich ab, inklusive E-Bikes. Auswahl von Versicherungsort und -summe möglich.'],
      [5, 'Empfehlenswert, wenn Sie von zuhause arbeiten oder Ihr Büro hochwertig ausgestattet haben.'],
      [6, 'Versichern Sie eine weitere Person mit eigener Wohnadresse ganz einfach mit. Ideal für Studierende, Schüler/innen und Lehrlinge.'],
      [7, 'Ihr Extraschutz gegen Schäden an Schwimmbecken und Whirlpools inklusive Schwimmbadtechnik.'],
      [8, 'Zusätzlicher Schutz für Ihre Heizungsanlage, auch für Wärmepumpen und Solaranlagen.'],
      [9, 'Sichern Sie sich gegen Bruchschäden der Gebäudeverglasung ab, auch in Garagen und Nebengebäuden.']
    ]);

  hvPaketIcons = new Map<number, string>([
    [1, 'assets/img/hv/Zusatzpakete/Icon-Naturkatastrophe-grau.png'],
    [2, 'assets/img/hv/Zusatzpakete/Icon-Elektrogeraete-grau.png'],
    [3, 'assets/img/hv/Zusatzpakete/Icon-Garten-grau.png'],
    [4, 'assets/img/hv/Zusatzpakete/Icon-Fahrrad-grau.png'],
    [5, 'assets/img/hv/Zusatzpakete/Icon-Buero-grau.png'],
    [6, 'assets/img/hv/Zusatzpakete/Icon-Student-grau.png'],
    [7, 'assets/img/hv/Zusatzpakete/Icon-Pool-grau.png'],
    [8, 'assets/img/hv/Zusatzpakete/Icon-Heizung-grau.png'],
    [9, 'assets/img/hv/Zusatzpakete/Icon-Glasschaeden-grau.png']
  ]);

  hvPaketShortenedNames = new Map<number, string>([
    [1, 'Naturkatastrophen'],
    [2, 'Elektro'],
    [3, 'Garten'],
    [4, 'Fahrrad'],
    [5, 'Büro'],
    [6, 'Studenten'],
    [7, 'Pool'],
    [8, 'Heizung'],
    [9, 'Glas']
  ]);

  hvPaketFactsheetEhUrls  = new Map<number, string>([
    [1, 'FACTSHEETEHNATURKATASTROPHENURL'],
    [3, 'FACTSHEETEHGARTENURL'],
    [7, 'FACTSHEETEHPOOLURL'],
    [8, 'FACTSHEETEHHEIZUNGURL'],
    [9, 'FACTSHEETEHGLASURL']
  ]);

  hvPaketFactsheetHhUrls  = new Map<number, string>([
    [1, 'FACTSHEETHHNATURKATASTROPHENURL'],
    [2, 'FACTSHEETHHELEKTROURL'],
    [3, 'FACTSHEETHHGARTENURL'],
    [4, 'FACTSHEETHHFAHRRADURL'],
    [5, 'FACTSHEETHHBUEROURL'],
    [6, 'FACTSHEETHHSTUDENTENURL'],
    [8, 'FACTSHEETHHHEIZUNGURL'],
  ]);

  hvBauweisen: Map<number, string> =
    new Map([
      [1, 'Holzbauweise'],
      [2, 'Gemischt'],
      [3, 'Massiv hart'],
      [4, 'Niedrigenergiehaus'],
    ]);

  hvNebenGebaeudeArten: Map<number, string> =
    new Map([
      [1, 'Garage'],
      [2, 'Carport'],
      [3, 'Gartenhaus'],
      [4, 'Poolhaus']
    ]);

  hvGebaeudeTypen: Map<number, string> =
    new Map([
      [0, 'Ein- oder Zweifamilienhaus'],
      [1, 'Reihenhaus'],
      [2, 'Doppelhaus'],
    ]);

  hvDachungen: Map<number, string> =
    new Map([
      [0, 'Satteldach'],
      [1, 'Walmdach'],
      [2, 'Pultdach'],
      [3, 'Flachdach'],
      [4, 'Andere']
    ]);

  hvEinrichtungen: Map<number, string> =
    new Map([
      [1, 'Komfortabel - wohnliche Ausstattung'],
      [2, 'Gehoben - hochwertige Ausstattung'],
    ]);

  hvVarianten: Map<number, string> =
    new Map([
      [1, 'Top-Eigenheim Vollschutz'],
      [2, 'Eigenheim Vollschutz'],
      [3, 'Top-Eigenheim Standardschutz'],
      [4, 'Eigenheim Standardschutz']
    ]);

  hvPaketGeltungsbereichVsSubTexte: Map<number, string> =
    new Map([
      [1010201, 'Im Schadensfall wird maximal diese Summe ausbezahlt, unabhängig von der Anzahl der Fahrräder.']
    ]);

  zahlungsarten: Observable<Array<ILookupValue>> = of([
    {
      Key: '1',
      Id: '1',
      Value: 'Jährlich'
    },
    {
      Key: '2',
      Id: '2',
      Value: 'Halbjährlich'
    },
    {
      Key: '3',
      Id: '3',
      Value: 'Vierteljährlich'
    },
    {
      Key: '4',
      Id: '4',
      Value: 'Monatlich'
    }]);

  hybridarten = new Map<number, string>([
    [1, 'FHEV - Vollhybrid/MHEV - Mildhybrid'],
    [2, 'PHEV - Plug-In Hybrid']
  ]);
}
